import React, { JSX } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useStorageKey } from './hooks/useStorage';

export default function SignUpRoute(): JSX.Element | null {
  const isSignUpCompleted = useStorageKey<boolean>('isSignUpCompleted');
  const shouldRender = useStorageKey<boolean>('shouldRender');

  if (!shouldRender) {
    return null;
  }

  if (isSignUpCompleted) {
    return <Navigate to="/" />;
  }

  return <Outlet />; // render the child routes if sign-up is not completed
}
